import _t from 'i18n!nls/discussions';

export const handlePaginationAriaLabel = (type: string, page?: number, selected?: boolean) => {
  if (selected) {
    return _t(`Page #{page}`, { page });
  }
  if (type === 'page') {
    return _t(`Go to page #{page}`, { page });
  }
  return _t(`Go to #{type} page`, { type });
};
